module.exports = __webpack_public_path__ + "static/media/transpRollet1.1a87129e.jpeg";